import { createFileRoute } from "@tanstack/react-router";
import { Vergleiche } from "../../features/shell/Vergleiche";

export const Route = createFileRoute("/vergleiche/")({
  component: Vergleiche,
});
